import { ConversationChannel } from '@vendasta/conversation';
import { ChatSource } from '@vendasta/galaxy/chat-composer/src/chat-composer.component';

export function mapConversationChannelToChatSource(channel: ConversationChannel, phoneNumber?: string): ChatSource {
  switch (channel) {
    case ConversationChannel.CONVERSATION_CHANNEL_SMS:
      return { id: 'sms', sourceName: 'SMS', account: phoneNumber };
    case ConversationChannel.CONVERSATION_CHANNEL_FACEBOOK:
      return { id: 'facebook', sourceName: 'Facebook Messenger', shortSourceName: 'Facebook' };
    case ConversationChannel.CONVERSATION_CHANNEL_GOOGLE_BUSINESS_COMMUNICATIONS:
      return { id: 'google', sourceName: 'Google Business Messages', shortSourceName: 'Google' };
    case ConversationChannel.CONVERSATION_CHANNEL_WEB_CHAT:
      return { id: 'webchat', sourceName: 'Web Chat' };
    case ConversationChannel.CONVERSATION_CHANNEL_OPENAI:
      return { id: 'openai', sourceName: '' };
    case ConversationChannel.CONVERSATION_CHANNEL_INTERNAL:
      return { id: 'platform', sourceName: 'Platform Chat', shortSourceName: 'Platform' };
    case ConversationChannel.CONVERSATION_CHANNEL_EMAIL:
      return { id: 'email', sourceName: 'Email' };
    case ConversationChannel.CONVERSATION_CHANNEL_INSTAGRAM:
      return { id: 'instagram', sourceName: 'Instagram Messenger' };
    case ConversationChannel.CONVERSATION_CHANNEL_WHATSAPP:
      return { id: 'whatsapp', sourceName: 'WhatsApp' };
    case ConversationChannel.CONVERSATION_CHANNEL_AI_ASSISTANT:
      return { id: 'ai-assistant', sourceName: '' };
    default:
      throw new Error(`Unknown conversation channel: ${channel}`);
  }
}
